import React from 'react';
import { useEffect, useState } from "react"
import { Button, Text, View } from "../../../Components/Themed"
import { MarketComponentApi } from "../../api"
import type { OrderProps, PublicPlayerProps } from "../../../types"
import { ActivityIndicator, FlatList, Image } from 'react-native';
import { useColors } from '../../../constants/useColors';
import { MyOrdersHelpers } from '../MyOrderList/api';

type OrderListProps = {
    order_ids:string[],
    onViewPlayer:(player_id:string) => void
    onViewOrder:(order_id:string) => void
    onClose:() => void
}
const OrderList = ({ order_ids, onClose, onViewOrder , onViewPlayer}:OrderListProps) => {
    const Colors = useColors();
    const [ list_data, setListData ] = useState<{
        loading:boolean,
        orders:OrderProps[],
        players:PublicPlayerProps[]
    }>({
        loading:false,
        orders:[],
        players:[]
    });
    const { loading, orders, players } = list_data;

    useEffect(() => {
        getOrders()
    },[JSON.stringify(order_ids)])

    const getOrders = async() => {
        setListData({ ...list_data, loading:true });
        const ords = await MarketComponentApi.getOrdersByIds(order_ids);
        const plys = await MarketComponentApi.getPlayersByIds([ ...new Set(ords.map(o => o.player_id))]);
        setListData({
            ...list_data,
            loading: false,
            orders:ords.filter(o => (o.called_amt > 0 || o.status == 'approved')),
            players:plys
        });
    }

    const renderOrders = (data:{ item:OrderProps, index:number }) => {
        const player = players.find(p => p.player_id == data.item.player_id);
        if(!player){ return <></> }
        const { called_amt, open_amt, net_earnings, original_stake, unresolved_potential_winnings, resolved_potential_winnings } = MyOrdersHelpers.calcAllOrderStats([data.item]);
        
        return (
            <View style={{ borderRadius:0, flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <Button style={{ padding:0 }} onPress={() => onViewPlayer(player.player_id)}>
                    <Image
                        source={{ uri: player?.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:30, width:30, borderRadius:100 }}
                        resizeMode='cover'
                    />
                </Button>
                <Button transparent style={{ flex:1, marginLeft:10, marginRight:5, padding:0 }} onPress={() => onViewOrder(data.item.order_id)}>
                    <Text theme='h2'>{data.item.title}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>@{player.username}</Text>
                </Button>
                {data.item.status == 'approved' ?
                <View style={{ justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h2'>${called_amt.toFixed(2)}</Text>
                    <Text theme='description' style={{ marginTop:3 }} size={10}>${open_amt.toFixed(2)}</Text>
                </View>
                :
                <View style={{ justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h2'>${original_stake.toFixed(2)}</Text>
                    <Text theme='description' style={{ marginTop:3 }} size={10}>to win {(resolved_potential_winnings+unresolved_potential_winnings).toFixed(2)}</Text>
                </View>
                }
                
                {data.item.resolution_status == 'closed' ?
                <View style={{ alignItems:'flex-end', marginLeft:10 }}>
                    <Text theme='h2' color={net_earnings < 0 ? Colors.text.error : Colors.text.success}>${net_earnings.toFixed(2)}</Text>
                    <Text theme='description' style={{ marginTop:3 }} size={10}>Net Earnings</Text>
                </View>
                :<></>}
            </View>
        )
    }
    return (
        <View float style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Order List</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Orders created under the selected criteria</Text>
                </View>
                <Button
                    title='X'
                    style={{ padding:10 }}
                    float
                    onPress={() => onClose()}
                />
            </View>
            <View style={{ flex:1 }}>
                {loading ?
                <ActivityIndicator style={{ padding:20, alignSelf:'center' }} size='large' color={Colors.text.h1} />
                :<></>}
                <FlatList
                    data={orders}
                    renderItem={renderOrders}
                    windowSize={5}
                    maxToRenderPerBatch={10}
                    key={'order_list'}
                    keyExtractor={(item) => item.order_id.toString()}
                />
            </View>
        </View>
    )
}

export default OrderList